import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import {
	CButton,
	CModal,CModalBody,CModalFooter,CModalHeader,CModalTitle,CCloseButton,
	CFormInput,CInputGroup,CInputGroupText,CFormSelect,CFormSwitch,
	CRow,CCol,
	CCard,CCardBody,
	CLink,
	CSpinner,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import { isMobile } from "react-device-detect";
import PropTypes from 'prop-types';
import { UFunc } from "../helpers/functions";
import { Konfirm } from '../helpers/onConfirm'

const pjson 	= require('../../package.json')
const MyDialogodontogram = (props) => {
	const {
		showToast,prosesExpired,setSessionaktif,
		show,toggle,dataSelectedArr,dataDeskripsiTerapi,onKlikSimpan,
		...rest
	} = props;

	const uDispatch 				= useDispatch();

	//--MUST_THERE--/
	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uEfekapp					= useSelector(state => state.effectApp);
	const [uEfekview,setEfekview] 	= React.useState(false);
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	//--END MUST_THERE--/

	//--LOCALVARS--/
	const uDataselectedArr						= dataSelectedArr || [];
	const [uDatagigiArr,setDatagigiArr]			= React.useState([]);
	const [uDatashowArr,setDatashowArr]			= React.useState([]);
	const [uDataprocessingArr,setDataprocessingArr]= React.useState([]);
	const [uISLoadingkomponen,setLoadingkomponen]= React.useState(false);
	const [uISExecutesimpan,setExecutesimpan]	= React.useState(false);
	const [uInpgigivalue,setInpgigivalue]		= React.useState();
	const [uInpsemuagigi,setInpsemuagigi]		= React.useState((uDataselectedArr[0]||{}).nomor_gigi === "ALL" ? "ALL" : "");
	//--END LOCALVARS--/

	//--DOM--/
	const uWindowwidth				= window.outerWidth;
	const uISTabletview				= uWindowwidth > 425 && uWindowwidth <= 768;
	const uISCellphoneview			= uWindowwidth <= 425;
	//--END DOM--*/

	//--HANDEL--/
	const hdlChangesemua = (_EV) => {
		if(_EV.target.checked) {
			setInpsemuagigi("ALL")
		} else {
			setInpsemuagigi("");
			setInpgigivalue(0);
		}
	}
	const hdlKliksimpan = () => {
		//--VALIDASI--/
		//--END VALIDASI--/
		
		//--SET_DISPATCH_DULU--/
		const vProcessingstr = uInpsemuagigi!=="ALL"
			? JSON.stringify(uDataprocessingArr)
			: JSON.stringify([{nomor_gigi:"ALL"}])
		uDispatch({type: "set", gigi_processing_str: vProcessingstr});
		//--END SET_DISPATCH_DULU--/

		setExecutesimpan(true);
	}
	const hdlKlikHapusgigi = async(_IDXKEY) => {
		_IDXKEY	= parseInt(_IDXKEY);

		const vNextfunction = () => {
			//--SPLICE_NYA_ERROR--/
			if(parseInt((uDataprocessingArr[_IDXKEY]||{}).id_item||0) > 0) {
				uDataprocessingArr[_IDXKEY] = {
					...(uDataprocessingArr[_IDXKEY]||{}),
					status_hapus: "YA",
				}
			} else {
				uDataprocessingArr.splice(_IDXKEY,1);
			}
			//--END SPLICE_NYA_ERROR--*/
			/*//--TIDAk_JADI--/
			uDataprocessingArr[_IDXKEY] = {
				...(uDataprocessingArr[_IDXKEY]||{}),
				status_hapus: "YA",
			}
			//--END TIDAk_JADI--*/
			setEfekview(!uEfekview);
		}

		if(await Konfirm("<b>Nomor Gigi "+((uDataprocessingArr[_IDXKEY]||{}).nomor_gigi || "UNDF")+" Akan Dihapus</b>.."+
			"<p class='fst-italic'>Apakah Anda Yakin ?</p>"+
			"")) {
			vNextfunction()
		}
	}
	const hdlKlikGigi = React.useCallback((_NOMORGIGI,_SURFACE) => {
		if(uDatashowArr.length <= 0) return;

		_NOMORGIGI		= parseInt(_NOMORGIGI); if(_NOMORGIGI <= 0) return;
		const vSurface	= "ALL";//(_SURFACE||"ALL").toUpperCase();

		//--CEK_NOMOR_GIGI--/
		const vIdxprocessing = UFunc.getObjectIndeks(uDataprocessingArr,_NOMORGIGI,"nomor_gigi");
		if(vIdxprocessing >= 0) {
			if((uDataprocessingArr[vIdxprocessing].status_hapus||"TIDAK")!=="YA") {
				showToast("<p><b>Nomor Gigi '"+_NOMORGIGI+"' Sudah Ditambahkan</b>..</p>"+
					"<p class='fst-italic'>Mohon Cek Kembali dan KLIK Hapus untuk Membatalkannya !</p>"+
					"");
				return;
			} else {
				uDataprocessingArr[vIdxprocessing] = {
					...(uDataprocessingArr[vIdxprocessing]||{}),
					status_hapus: "TIDAK",
				}
				setEfekview(!uEfekview);
				return;
			}
		}
		//--END CEK_NOMOR_GIGI--/

		setInpgigivalue(0);
		const vArridx		= UFunc.getObjectIndeks(uDatashowArr,_NOMORGIGI,"nomor_gigi");
		const vTmpObj		= {
			id_item: 0,//->ID_TPASIEN_ODONTOGRAM_KALO_SUDAH_ADA--/
			id_gigi: parseInt((uDatashowArr[vArridx]||{}).id)||0,
			nomor_gigi	: _NOMORGIGI,
			nama_gigi	: (uDatashowArr[vArridx]||{}).nama_gigi || "Undf",
			kondisi_id	: 0,
			kondisi_caption	: "",
			kondisi_kode	: "",
			kondisi_simbol	: "",
			surface	: vSurface,
			catatan: "",
		};

		setInpsemuagigi("");
		setDataprocessingArr([...uDataprocessingArr,vTmpObj]);
	},[uDatashowArr.length,uDataprocessingArr.length]);
	//--END HANDEL--/

	//--PROCEDURE--/
	//--END PROCEDURE--/

	//--CONTENT--/
	const ContentToothM = React.useMemo(()=>{ 
		return React.memo(({ number, posisi, sisi, jenis}) => {
			const vKondisiinputArr	= uDataprocessingArr.filter(vItems=> 
				parseInt(vItems.nomor_gigi)===parseInt(number)	&&
				(vItems.status_hapus||"TIDAK")!=="YA"
				);

			let vSimbolteks = "";
			let vSimbolimageArr			= [];
			let vSimbolcolormesial 		= "";
			let vSimbolcolordistal 		= "";
			let vSimbolcolorlingual 	= "";
			let vSimbolcolorvestibular 	= "";
			let vSimbolcoloroccusal 	= "";
			let vSimbolcolorall 		= "";
			let vKondisiidx;

			if(vKondisiinputArr.length > 0) {
				let vTekstmp	= "";
				vKondisiinputArr.forEach(vItems => {
					//--TEKS--/
					if(vItems.kondisi_simbol==="TEKS") {
						if(vTekstmp	=== "") {
							vSimbolteks 	= vItems.kondisi_kode;
							vTekstmp		= vItems.kondisi_kode;
						}
					}
					//--END TEKS--/

					//--COLOR--/
					if(vItems.kondisi_simbol==="COLOR") {
						if(vItems.surface === "OCCUSAL")
							vSimbolcoloroccusal	+= " class"+(vItems.kondisi_kode||"").toLowerCase();
						else if(vItems.surface === "MESIAL")
							vSimbolcolormesial	+= " class"+(vItems.kondisi_kode||"").toLowerCase();
						else if(vItems.surface === "DISTAL")
							vSimbolcolordistal	+= " class"+(vItems.kondisi_kode||"").toLowerCase();
						else if(vItems.surface === "LINGUAL")
							vSimbolcolorlingual	+= " class"+(vItems.kondisi_kode||"").toLowerCase();
						else if(vItems.surface === "VESTIBULAR")
							vSimbolcolorvestibular	+= " class"+(vItems.kondisi_kode||"").toLowerCase();
						else
							vSimbolcolorall	+= " class"+(vItems.kondisi_kode||"").toLowerCase();
					}
					//--END COLOR--/

					//--IMAGE--/
					if(vItems.kondisi_simbol==="IMAGE") {
						let vPoints;
						if((vItems.kondisi_kode||"").toLowerCase()==="abu") {
							vPoints		= "0 30,44 30,44 41, 0 41";
							vSimbolimageArr.push(
							<polygon points={vPoints} alt="IMAGE" strokeWidth="5" stroke="black" fill="gray"/>
							)//>
						}
						if((vItems.kondisi_kode||"").toLowerCase()==="cfr") {
							vPoints		= "58";
							vSimbolimageArr.push(
								<text x="22" y={vPoints} 
									textAnchor="middle" fontSize="60" font-weight="bold">#</text>
							)//>
						}
						if((vItems.kondisi_kode||"").toLowerCase()==="mam") {
							vPoints		= "68";
							vSimbolimageArr.push(
							<text x="22" y={vPoints} textAnchor="middle" fontSize="110">&times;</text>
							)//>
						}
						if((vItems.kondisi_kode||"").toLowerCase()==="meb") {
							vPoints		= "0 30,44 30,44 41, 0 41";
							vSimbolimageArr.push(
							<polygon points={vPoints} alt="IMAGE" strokeWidth="5" stroke="black" fill="red"/>
							)//>
						}
						if((vItems.kondisi_kode||"").toLowerCase()==="mis") {
							vPoints		= "68";
							vSimbolimageArr.push(
							<text x="22" y={vPoints} textAnchor="middle" fontSize="110">&times;</text>
							)//>
						}
						if((vItems.kondisi_kode||"").toLowerCase()==="mpm") {
							vSimbolimageArr.push(
								<circle cx="22" cy="35" r="20" fill="none" stroke="black" strokeWidth="3"/>
							)//>
						}
						if((vItems.kondisi_kode||"").toLowerCase()==="nvt") {
							vPoints	= (posisi === "ATAS") ? "14 58, 30 58, 22 70" : "14 12, 30 12, 22 0";

							vSimbolimageArr.push(
							<polygon points={vPoints} alt="IMAGE" strokeWidth="2" fill="none" stroke="black"/> 
							)//>
						}
						if((vItems.kondisi_kode||"").toLowerCase()==="pob") {
							vPoints		= "0 30,44 30,44 41, 0 41";
							vSimbolimageArr.push(
							<polygon points={vPoints} alt="IMAGE" strokeWidth="5" stroke="black" fill="green"/>
							)//>
						}
						if((vItems.kondisi_kode||"").toLowerCase(	)==="pon") {
							vPoints		= "68";
							vSimbolimageArr.push(
							<text x="22" y={vPoints} textAnchor="middle" fontSize="110">&times;</text>
							)//>
							vSimbolimageArr.push(
							<polygon points="3 15, 42 15, 42 55, 3 55" stroke="black" strokeWidth="5" fill="none"/>
							)//>
						}
						if((vItems.kondisi_kode||"").toLowerCase()==="rct") {
							vPoints	= (posisi === "ATAS") ? "14 58, 30 58, 22 70" : "14 12, 30 12, 22 0";

							vSimbolimageArr.push(
							<polygon points={vPoints} alt="IMAGE" strokeWidth="1" fill="black" stroke="black"/> 
							)//>
						}
						if((vItems.kondisi_kode||"").toLowerCase()==="rrx") {
							vPoints		= "60";
							vSimbolimageArr.push(
							<text x="22" y={vPoints} textAnchor="middle" fontSize="65">V</text>
							)//>
						}
					}
					//--END IMAGE--/

					//--TANPA_KONDISI--/
					vSimbolcolorall = " classnokondisi";
					//--END TANPA_KONDISI--*/
				});
			}

			if(uInpsemuagigi==="ALL") {
				vSimbolcolorall = " classsemuagigi";
			}

			//console.log("(MyCardodontogram - ContentTooth) ["+number+"] vKondisihistoriArr => "+JSON.stringify(vKondisihistoriArr))
			//console.log("(MyCardodontogram - ContentTooth) ["+number+"] vSimbolteks => "+(vSimbolteks))

			if(isMobile) {
				if(posisi === "ATAS" && jenis === "GIGI_SERI") return (
				<svg width="44" height="70" viewBox="0 0 44 70" className="classtooth-svg"
					onClick={() => hdlKlikGigi(number)}>
					<text x="22" y="11" textAnchor="middle" fontSize="12">{number}</text>
					
					{vSimbolteks !== "" && (
					<text x="22" y="67" textAnchor="middle" fontSize="13" font-weight="bold">{vSimbolteks}</text>
					)}

					<polygon points="3 15, 41 15, 41 55, 3 55" alt="ALL" className={"classall"+vSimbolcolorall}/>

					{vSimbolimageArr.map(vItems => vItems)}

					<polygon points="0 13, 44 13, 32 35, 12 35" alt="ATAS"
						className={"classsurfacem"+vSimbolcolorvestibular}/>

					<polygon points="32 35, 44 13, 44 57" alt="KANAN"
						className={"classsurfacem"+(sisi==="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}/>

					<polygon points="12 35, 32 35, 44 57, 0 57" alt="BAWAH"
						className={"classsurfacem"+vSimbolcolorlingual}/>

					<polygon points="0 13, 12 35, 0 57" alt="KIRI"
						className={"classsurfacem"+(sisi!=="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}/>
					
					<polygon points="0 13, 44 13, 44 57, 0 57" alt="ALL" className="classklikall"/>
				</svg>
				)//->


				if(posisi === "BAWAH" && jenis === "GIGI_SERI") return (
				<svg width="44" height="70" viewBox="0 0 44 70" className="classtooth-svg"
					onClick={() => hdlKlikGigi(number)}>
					<text x="22" y="70" textAnchor="middle" fontSize="12">{number}</text>

					{vSimbolteks !== "" && (
					<text x="22" y="11" textAnchor="middle" fontSize="13" font-weight="bold">{vSimbolteks}</text>
					)}

					<polygon points="3 15, 41 15, 41 55, 3 55" alt="ALL" className={"classall"+vSimbolcolorall}/>

					{vSimbolimageArr.map(vItems => vItems)}

					<polygon points="0 13, 44 13, 32 35, 12 35" alt="ATAS"
						className={"classsurfacem"+vSimbolcolorlingual}/>

					<polygon points="32 35, 44 13, 44 57" alt="KANAN"
						className={"classsurfacem"+(sisi!=="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}/>

					<polygon points="12 35, 32 35, 44 57, 0 57" alt="BAWAH"
						className={"classsurfacem"+vSimbolcolorvestibular}/>

					<polygon points="0 13, 12 35, 0 57" alt="KIRI"
						className={"classsurfacem"+(sisi==="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}/>
					
					<polygon points="0 13, 44 13, 44 57, 0 57" alt="ALL" className="classklikall"/>
				</svg>
				)//->

				if(posisi === "BAWAH" && jenis === "GIGI_GERAHAM") return (
				<svg width="44" height="70" viewBox="0 0 44 70" className="classtooth-svg"
					onClick={() => hdlKlikGigi(number,'LINGUAL')}>
					<text x="22" y="70" textAnchor="middle" fontSize="12">{number}</text>
					
					{vSimbolteks !== "" && (
					<text x="22" y="11" textAnchor="middle" fontSize="13" font-weight="bold">{vSimbolteks}</text>
					)}
						
					<polygon points="3 16, 41 16, 41 55, 3 55" alt="ALL" className={"classall"+vSimbolcolorall}/>

					{vSimbolimageArr.map(vItems => vItems)}

					<polygon points="0 13, 44 13, 32 25, 12 25"
						className={"classsurfacem"+vSimbolcolorlingual}/>

					<polygon points="44 13, 44 57, 32 46, 32 25"
						className={"classsurfacem"+(sisi!=="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}/>

					<polygon points="12 46, 32 46, 44 57, 0 57"
						className={"classsurfacem"+vSimbolcolorvestibular}/>

					<polygon points="0 13, 12 25, 12 46, 0 57"
						className={"classsurfacem"+(sisi==="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}/>

					<polygon points="12 25, 32 25, 32 46, 12 46"
						className={"classsurfacem"+vSimbolcoloroccusal} />

					<polygon points="0 13, 44 13, 44 57, 0 57" alt="ALL" className="classklikall"/>
				</svg>
				)//->

				return (
				<svg width="44" height="70" viewBox="0 0 44 70" className="classtooth-svg"
					onClick={() => hdlKlikGigi(number)}>
					<text x="22" y="11" textAnchor="middle" fontSize="12">{number}</text>
					
					{vSimbolteks !== "" && (
					<text x="22" y="67" textAnchor="middle" fontSize="13" font-weight="bold">{vSimbolteks}</text>
					)}

					<polygon points="3 15, 41 15, 41 55, 3 55" alt="ALL" className={"classall"+vSimbolcolorall}/>

					{vSimbolimageArr.map(vItems => vItems)}

					<polygon points="0 13, 44 13, 32 25, 12 25"
						className={"classsurfacem"+vSimbolcolorvestibular}/>

					<polygon points="44 13, 44 57, 32 46, 32 25"
						className={"classsurfacem"+(sisi==="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)} />

					<polygon points="12 46, 32 46, 44 57, 0 57"
						className={"classsurfacem"+vSimbolcolorlingual}/>

					<polygon points="0 13, 12 25, 12 46, 0 57"
						className={"classsurfacem"+(sisi!=="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}/>

					<polygon points="12 25, 32 25, 32 46, 12 46"
						className={"classsurfacem"+vSimbolcoloroccusal}/>

					<polygon points="0 13, 44 13, 44 57, 0 57" alt="ALL" className="classklikall"/>
				</svg>
				)//->
			}//-*/

			if(posisi === "ATAS" && jenis === "GIGI_SERI") return (
			<svg width="44" height="70" viewBox="0 0 44 70" className="classtooth-svg">
				<text x="22" y="11" textAnchor="middle" fontSize="12">{number}</text>
				
				{vSimbolteks !== "" && (
					<text x="22" y="67" textAnchor="middle" fontSize="13" font-weight="bold">{vSimbolteks}</text>
				)}

				<polygon points="3 15, 41 15, 41 55, 3 55" alt="ALL" className={"classall"+vSimbolcolorall}/>

				{vSimbolimageArr.map(vItems => vItems)}

				<polygon points="0 13, 44 13, 32 35, 12 35" alt="ATAS"
					className={"classsurface"+vSimbolcolorvestibular}
					onClick={() => hdlKlikGigi(number,'VESTIBULAR')} />

				<polygon points="32 35, 44 13, 44 57" alt="KANAN"
					className={"classsurface"+(sisi==="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}
					onClick={() => hdlKlikGigi(number,(sisi==="KANAN" ? "MESIAL" : "DISTAL"))} />

				<polygon points="12 35, 32 35, 44 57, 0 57" alt="BAWAH"
					className={"classsurface"+vSimbolcolorlingual}
					onClick={() => hdlKlikGigi(number,'LINGUAL')} />

				<polygon points="0 13, 12 35, 0 57" alt="KIRI"
					className={"classsurface"+(sisi!=="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}
					onClick={() => hdlKlikGigi(number,(sisi!=="KANAN" ? "MESIAL" : "DISTAL"))} />
			</svg>
			)//->

			if(posisi === "BAWAH" && jenis === "GIGI_SERI") return (
			<svg width="44" height="70" viewBox="0 0 44 70" className="classtooth-svg">
				<text x="22" y="70" textAnchor="middle" fontSize="12">{number}</text>

				{vSimbolteks !== "" && (
				<text x="22" y="11" textAnchor="middle" fontSize="13" font-weight="bold">{vSimbolteks}</text>
				)}

				<polygon points="3 15, 41 15, 41 55, 3 55" alt="ALL" className={"classall"+vSimbolcolorall}/>

				{vSimbolimageArr.map(vItems => vItems)}

				<polygon points="0 13, 44 13, 32 35, 12 35" alt="ATAS"
					className={"classsurface"+vSimbolcolorlingual}
					onClick={() => hdlKlikGigi(number,'LINGUAL')} />

				<polygon points="32 35, 44 13, 44 57" alt="KANAN"
					className={"classsurface"+(sisi!=="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}
					onClick={() => hdlKlikGigi(number,(sisi!=="KANAN" ? "MESIAL" : "DISTAL"))} />

				<polygon points="12 35, 32 35, 44 57, 0 57" alt="BAWAH"
					className={"classsurface"+vSimbolcolorvestibular}
					onClick={() => hdlKlikGigi(number,'VESTIBULAR')} />

				<polygon points="0 13, 12 35, 0 57" alt="KIRI"
					className={"classsurface"+(sisi==="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}
					onClick={() => hdlKlikGigi(number,(sisi==="KANAN" ? "MESIAL" : "DISTAL"))} />
			</svg>
			)//->

			if(posisi === "BAWAH" && jenis === "GIGI_GERAHAM") return (
			<svg width="44" height="70" viewBox="0 0 44 70" className="classtooth-svg">
				<text x="22" y="70" textAnchor="middle" fontSize="12">{number}</text>
				
				{vSimbolteks !== "" && (
				<text x="22" y="11" textAnchor="middle" fontSize="13" font-weight="bold">{vSimbolteks}</text>
				)}
					
				<polygon points="3 15, 41 15, 41 55, 3 55" alt="ALL" className={"classall"+vSimbolcolorall}/>

				{vSimbolimageArr.map(vItems => vItems)}

				<polygon points="0 13, 44 13, 32 25, 12 25"
					className={"classsurface"+vSimbolcolorlingual}
					onClick={() => hdlKlikGigi(number,'LINGUAL')} />

				<polygon points="44 13, 44 57, 32 46, 32 25"
					className={"classsurface"+(sisi!=="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}
					onClick={() => hdlKlikGigi(number,(sisi!=="KANAN" ? "MESIAL" : "DISTAL"))} />

				<polygon points="12 46, 32 46, 44 57, 0 57"
					className={"classsurface"+vSimbolcolorvestibular}
					onClick={() => hdlKlikGigi(number,'VESTIBULAR')} />

				<polygon points="0 13, 12 25, 12 46, 0 57"
					className={"classsurface"+(sisi==="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}
					onClick={() => hdlKlikGigi(number,(sisi==="KANAN" ? "MESIAL" : "DISTAL"))} />

				<polygon points="12 25, 32 25, 32 46, 12 46"
					className={"classsurface ${vSimbolcoloroccusal}"}
					onClick={() => hdlKlikGigi(number,'OCCUSAL')} />
			</svg>
			)//->

			return (
			<svg width="44" height="70" viewBox="0 0 44 70" className="classtooth-svg">
				<text x="22" y="11" textAnchor="middle" fontSize="12">{number}</text>
				
				{vSimbolteks !== "" && (
					<text x="22" y="67" textAnchor="middle" fontSize="13" font-weight="bold">{vSimbolteks}</text>
				)}

				<polygon points="3 15, 41 15, 41 55, 3 55" alt="ALL" className={"classall"+vSimbolcolorall}/>

				{vSimbolimageArr.map(vItems => vItems)}

				<polygon points="0 13, 44 13, 32 25, 12 25"
					className={"classsurface"+vSimbolcolorvestibular}
					onClick={() => hdlKlikGigi(number,'VESTIBULAR')} />

				<polygon points="44 13, 44 57, 32 46, 32 25"
					className={"classsurface"+(sisi==="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}
					onClick={() => hdlKlikGigi(number,(sisi==="KANAN" ? "MESIAL" : "DISTAL"))} />

				<polygon points="12 46, 32 46, 44 57, 0 57"
					className={"classsurface"+vSimbolcolorlingual}
					onClick={() => hdlKlikGigi(number,'LINGUAL')} />

				<polygon points="0 13, 12 25, 12 46, 0 57"
					className={"classsurface"+(sisi!=="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}
					onClick={() => hdlKlikGigi(number,(sisi!=="KANAN" ? "MESIAL" : "DISTAL"))} />

				<polygon points="12 25, 32 25, 32 46, 12 46"
					className={"classsurface ${vSimbolcoloroccusal}"}
					onClick={() => hdlKlikGigi(number,'OCCUSAL')} />
			</svg>
			)//->
		});
	},[uDatashowArr.length,
	uDataprocessingArr.length,
	uInpsemuagigi,
	]);

	const ContentTooth = React.useMemo(()=>{ 
		return React.memo(({ number, posisi, sisi, jenis}) => {
			const vKondisiinputArr	= uDataprocessingArr.filter(vItems=> 
				parseInt(vItems.nomor_gigi)===parseInt(number)	&&
				(vItems.status_hapus||"TIDAK")!=="YA"
				);

			let vSimbolteks 			= "";
			let vSimbolimageArr			= [];
			let vSimbolcolormesial 		= "";
			let vSimbolcolordistal 		= "";
			let vSimbolcolorlingual 	= "";
			let vSimbolcolorvestibular 	= "";
			let vSimbolcoloroccusal 	= "";
			let vSimbolcolorall = "";
			let vKondisiidx;

			if(vKondisiinputArr.length > 0) {
				let vTekstmp	= "";
				vKondisiinputArr.forEach(vItems => {
					//--TEKS--/
					if(vItems.kondisi_simbol==="TEKS") {
						if(vTekstmp	=== "") {
							vSimbolteks 	= vItems.kondisi_kode;
							vTekstmp		= vItems.kondisi_kode;
						}
					}
					//--END TEKS--/

					//--COLOR--/
					if(vItems.kondisi_simbol==="COLOR") {
						if(vItems.surface === "OCCUSAL")
							vSimbolcoloroccusal	+= " class"+(vItems.kondisi_kode||"").toLowerCase();
						else if(vItems.surface === "MESIAL")
							vSimbolcolormesial	+= " class"+(vItems.kondisi_kode||"").toLowerCase();
						else if(vItems.surface === "DISTAL")
							vSimbolcolordistal	+= " class"+(vItems.kondisi_kode||"").toLowerCase();
						else if(vItems.surface === "LINGUAL")
							vSimbolcolorlingual	+= " class"+(vItems.kondisi_kode||"").toLowerCase();
						else if(vItems.surface === "VESTIBULAR")
							vSimbolcolorvestibular	+= " class"+(vItems.kondisi_kode||"").toLowerCase();
						else
							vSimbolcolorall	+= " class"+(vItems.kondisi_kode||"").toLowerCase();
					}
					//--END COLOR--/

					//--IMAGE--/
					if(vItems.kondisi_simbol==="IMAGE") {
						let vPoints;
						if((vItems.kondisi_kode||"").toLowerCase()==="abu") {
							vPoints		= "0 33,48 33,48 45, 0 45";
							vSimbolimageArr.push(
							<polygon points={vPoints} alt="IMAGE" strokeWidth="5" stroke="black" fill="gray"/>
							)//>
						}
						if((vItems.kondisi_kode||"").toLowerCase()==="cfr") {
							vPoints		= "62";
							vSimbolimageArr.push(
								<text x="24" y={vPoints} 
									textAnchor="middle" fontSize="60" font-weight="bold">#</text>
							)//>
						}
						if((vItems.kondisi_kode||"").toLowerCase()==="mam") {
							vPoints		= "73";
							vSimbolimageArr.push(
							<text x="24" y={vPoints} textAnchor="middle" fontSize="115">&times;</text>
							)//>
						}
						if((vItems.kondisi_kode||"").toLowerCase()==="meb") {
							vPoints		= "0 33,48 33,48 45, 0 45";
							vSimbolimageArr.push(
							<polygon points={vPoints} alt="IMAGE" strokeWidth="5" stroke="black" fill="red"/>
							)//>
						}
						if((vItems.kondisi_kode||"").toLowerCase()==="mis") {
							vPoints		= "73";
							vSimbolimageArr.push(
							<text x="24" y={vPoints} textAnchor="middle" fontSize="115">&times;</text>
							)//>
						}
						if((vItems.kondisi_kode||"").toLowerCase()==="mpm") {
							vSimbolimageArr.push(
								<circle cx="24" cy="39" r="22" fill="none" stroke="black" strokeWidth="3"/>
							)//>
						}
						if((vItems.kondisi_kode||"").toLowerCase()==="nvt") {
							vPoints	= (posisi === "ATAS") ? "16 64, 32 64, 24 78" : "16 14, 32 14, 24 0";

							vSimbolimageArr.push(
							<polygon points={vPoints} alt="IMAGE" strokeWidth="2" fill="none" stroke="black"/> 
							)//>
						}
						if((vItems.kondisi_kode||"").toLowerCase()==="pob") {
							vPoints		= "0 33,48 33,48 45, 0 45";
							vSimbolimageArr.push(
							<polygon points={vPoints} alt="IMAGE" strokeWidth="5" stroke="black" fill="green"/>
							)//>
						}
						if((vItems.kondisi_kode||"").toLowerCase(	)==="pon") {
							vPoints		= "73";
							vSimbolimageArr.push(
							<text x="24" y={vPoints} textAnchor="middle" fontSize="115">&times;</text>
							)//>
							vSimbolimageArr.push(
							<polygon points="3 15, 45 15, 45 63, 3 63" stroke="black" strokeWidth="5" fill="none"/>
							)//>
						}
						if((vItems.kondisi_kode||"").toLowerCase()==="rct") {
							vPoints	= (posisi === "ATAS") ? "16 64, 32 64, 24 75" : "16 14, 32 14, 24 0";

							vSimbolimageArr.push(
							<polygon points={vPoints} alt="IMAGE" strokeWidth="1" fill="black" stroke="black"/> 
							)//>
						}
						if((vItems.kondisi_kode||"").toLowerCase()==="rrx") {
							vPoints		= "62";
							vSimbolimageArr.push(
							<text x="24" y={vPoints} textAnchor="middle" fontSize="65">V</text>
							)//>
						}
					}
					//--END IMAGE--/

					//--TANPA_KONDISI--/
					vSimbolcolorall = " classnokondisi";
					//--END TANPA_KONDISI--*/
				});
			}

			if(uInpsemuagigi==="ALL") {
				vSimbolcolorall = " classsemuagigi";
			}

			//console.log("(MyCardodontogram - ContentTooth) ["+number+"] vKondisihistoriArr => "+JSON.stringify(vKondisihistoriArr))
			//console.log("(MyCardodontogram - ContentTooth) ["+number+"] vSimbolteks => "+(vSimbolteks))

			if(isMobile) {
				if(posisi === "ATAS" && jenis === "GIGI_SERI") return (
				<svg width="48" height="78" viewBox="0 0 48 78" className="classtooth-svg"
					onClick={() => hdlKlikGigi(number)}>
					<text x="23" y="13" textAnchor="middle" fontSize="13">{number}</text>
					
					{vSimbolteks !== "" && (
					<text x="23" y="74" textAnchor="middle" fontSize="15" font-weight="bold">{vSimbolteks}</text>
					)}

					<polygon points="3 15, 45 15, 45 63, 3 63" alt="ALL" className={"classall"+vSimbolcolorall}/>

					{vSimbolimageArr.map(vItems => vItems)}

					<polygon points="0 15, 48 15, 34 39, 14 39" alt="ATAS"
						className={"classsurfacem"+vSimbolcolorvestibular}/>

					<polygon points="34 39, 48 15, 48 63" alt="KANAN"
						className={"classsurfacem"+(sisi==="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}/>

					<polygon points="14 39, 34 39, 48 63, 0 63" alt="BAWAH"
						className={"classsurfacem"+vSimbolcolorlingual}/>

					<polygon points="0 15, 14 39, 0 63" alt="KIRI"
						className={"classsurfacem"+(sisi!=="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}/>
					
					<polygon points="0 13, 44 13, 44 57, 0 57" alt="ALL" className="classklikall"/>
				</svg>
				)//->


				if(posisi === "BAWAH" && jenis === "GIGI_SERI") return (
				<svg width="48" height="78" viewBox="0 0 48 78" className="classtooth-svg"
					onClick={() => hdlKlikGigi(number)}>
					<text x="23" y="74" textAnchor="middle" fontSize="13">{number}</text>

					{vSimbolteks !== "" && (
					<text x="23" y="12" textAnchor="middle" fontSize="15" font-weight="bold">{vSimbolteks}</text>
					)}

					<polygon points="3 15, 45 15, 45 63, 3 63" alt="ALL" className={"classall"+vSimbolcolorall}/>

					{vSimbolimageArr.map((vItems,vKeys) => (<React.Fragment key={vKeys}>{vItems}</React.Fragment>))}

					<polygon points="0 15, 48 15, 34 39, 14 39"
						className={"classsurfacem"+vSimbolcolorlingual}/>

					<polygon points="34 39, 48 15, 48 63"
						className={"classsurfacem"+(sisi!=="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}/>

					<polygon points="14 39, 34 39, 48 63, 0 63"
						className={"classsurfacem"+vSimbolcolorvestibular}/>

					<polygon points="0 15, 14 39, 0 63"
						className={"classsurfacem"+(sisi==="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}/>

					<polygon points="0 13, 44 13, 44 57, 0 57" alt="ALL" className="classklikall"/>
				</svg>
				)//->

				if(posisi === "BAWAH" && jenis === "GIGI_GERAHAM") return (
				<svg width="48" height="78" viewBox="0 0 48 78" className="classtooth-svg"
					onClick={() => hdlKlikGigi(number,'LINGUAL')}>
					<text x="23" y="74" textAnchor="middle" fontSize="13">{number}</text>
					
					{vSimbolteks !== "" && (
					<text x="23" y="12" textAnchor="middle" fontSize="15" font-weight="bold">{vSimbolteks}</text>
					)}
						
					<polygon points="3 15, 45 15, 45 63, 3 63" alt="ALL" className={"classall"+vSimbolcolorall}/>

					{vSimbolimageArr.map(vItems => vItems)}

					<polygon points="0 15, 48 15, 34 29, 14 29"
						className={"classsurfacem"+vSimbolcolorlingual}/>

					<polygon points="48 15, 48 63, 34 49, 34 29"
						className={"classsurfacem"+(sisi!=="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}/>

					<polygon points="14 49, 34 49, 48 63, 0 63"
						className={"classsurfacem"+vSimbolcolorvestibular}/>

					<polygon points="0 15, 14 29, 14 49, 0 63"
						className={"classsurfacem"+(sisi==="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}/>

					<polygon points="14 29, 34 29, 34 49, 14 49"
						className={"classsurfacem"+vSimbolcoloroccusal} />

					<polygon points="0 13, 44 13, 44 57, 0 57" alt="ALL" className="classklikall"/>
				</svg>
				)//->

				return (
				<svg width="48" height="78" viewBox="0 0 48 78" className="classtooth-svg"
					onClick={() => hdlKlikGigi(number)}>
					<text x="23" y="13" textAnchor="middle" fontSize="13">{number}</text>
					
					{vSimbolteks !== "" && (
					<text x="23" y="74" textAnchor="middle" fontSize="15" font-weight="bold">{vSimbolteks}</text>
					)}

					<polygon points="3 15, 45 15, 45 63, 3 63" alt="ALL" className={"classall"+vSimbolcolorall}/>

					{vSimbolimageArr.map((vItems,vKeys) => (<React.Fragment key={vKeys}>{vItems}</React.Fragment>))}

					<polygon points="0 15, 48 15, 34 29, 14 29"
						className={"classsurfacem"+vSimbolcolorvestibular}/>

					<polygon points="48 15, 48 63, 34 49, 34 29"
						className={"classsurfacem"+(sisi==="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)} />

					<polygon points="14 49, 34 49, 48 63, 0 63"
						className={"classsurfacem"+vSimbolcolorlingual}/>

					<polygon points="0 15, 14 29, 14 49, 0 63"
						className={"classsurfacem"+(sisi!=="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}/>

					<polygon points="14 29, 34 29, 34 49, 14 49"
						className={"classsurfacem"+vSimbolcoloroccusal}/>

					<polygon points="0 13, 44 13, 44 57, 0 57" alt="ALL" className="classklikall"/>
				</svg>
				)//->
			}//-*/

			if(posisi === "ATAS" && jenis === "GIGI_SERI") return (
			<svg width="48" height="78" viewBox="0 0 48 78" className="classtooth-svg">
				<text x="23" y="13" textAnchor="middle" fontSize="13">{number}</text>
				
				{vSimbolteks !== "" && (
				<text x="23" y="74" textAnchor="middle" fontSize="15" font-weight="bold">{vSimbolteks}</text>
				)}

				<polygon points="3 15, 45 15, 45 63, 3 63" alt="ALL" className={"classall"+vSimbolcolorall}/>

				{vSimbolimageArr.map((vItems,vKeys) => (<React.Fragment key={vKeys}>{vItems}</React.Fragment>))}

				<polygon points="0 15, 48 15, 34 39, 14 39" alt="ATAS"
					className={"classsurface"+vSimbolcolorvestibular}
					onClick={() => hdlKlikGigi(number,'VESTIBULAR')} />

				<polygon points="34 39, 48 15, 48 63" alt="KANAN"
					className={"classsurface"+(sisi==="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}
					onClick={() => hdlKlikGigi(number,(sisi==="KANAN" ? "MESIAL" : "DISTAL"))} />

				<polygon points="14 39, 34 39, 48 63, 0 63" alt="BAWAH"
					className={"classsurface"+vSimbolcolorlingual}
					onClick={() => hdlKlikGigi(number,'LINGUAL')} />

				<polygon points="0 15, 14 39, 0 63" alt="KIRI"
					className={"classsurface"+(sisi!=="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}
					onClick={() => hdlKlikGigi(number,(sisi!=="KANAN" ? "MESIAL" : "DISTAL"))} />
			</svg>
			)//->

			if(posisi === "BAWAH" && jenis === "GIGI_SERI") return (
			<svg width="48" height="78" viewBox="0 0 48 78" className="classtooth-svg">
				<text x="23" y="74" textAnchor="middle" fontSize="13">{number}</text>

				{vSimbolteks !== "" && (
				<text x="23" y="12" textAnchor="middle" fontSize="15" font-weight="bold">{vSimbolteks}</text>
				)}

				<polygon points="3 15, 45 15, 45 63, 3 63" alt="ALL" className={"classall"+vSimbolcolorall}/>

				{vSimbolimageArr.map((vItems,vKeys) => (<React.Fragment key={vKeys}>{vItems}</React.Fragment>))}

				<polygon points="0 15, 48 15, 34 39, 14 39"
					className={"classsurface"+vSimbolcolorlingual}
					onClick={() => hdlKlikGigi(number,'LINGUAL')} />

				<polygon points="34 39, 48 15, 48 63"
					className={"classsurface"+(sisi!=="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}
					onClick={() => hdlKlikGigi(number,(sisi!=="KANAN" ? "MESIAL" : "DISTAL"))} />

				<polygon points="14 39, 34 39, 48 63, 0 63"
					className={"classsurface"+vSimbolcolorvestibular}
					onClick={() => hdlKlikGigi(number,'VESTIBULAR')} />

				<polygon points="0 15, 14 39, 0 63"
					className={"classsurface"+(sisi==="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}
					onClick={() => hdlKlikGigi(number,(sisi==="KANAN" ? "MESIAL" : "DISTAL"))} />
			</svg>
			)//->

			if(posisi === "BAWAH" && jenis === "GIGI_GERAHAM") return (
			<svg width="48" height="78" viewBox="0 0 48 78" className="classtooth-svg">
				<text x="23" y="74" textAnchor="middle" fontSize="13">{number}</text>
				
				{vSimbolteks !== "" && (
				<text x="23" y="12" textAnchor="middle" fontSize="15" font-weight="bold">{vSimbolteks}</text>
				)}
					
				<polygon points="3 15, 45 15, 45 63, 3 63" alt="ALL" className={"classall"+vSimbolcolorall}/>

				{vSimbolimageArr.map((vItems,vKeys) => (<React.Fragment key={vKeys}>{vItems}</React.Fragment>))}

				<polygon points="0 15, 48 15, 34 29, 14 29"
					className={"classsurface"+vSimbolcolorlingual}
					onClick={() => hdlKlikGigi(number,'LINGUAL')} />

				<polygon points="48 15, 48 63, 34 49, 34 29"
					className={"classsurface"+(sisi!=="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}
					onClick={() => hdlKlikGigi(number,(sisi!=="KANAN" ? "MESIAL" : "DISTAL"))} />

				<polygon points="14 49, 34 49, 48 63, 0 63"
					className={"classsurface"+vSimbolcolorvestibular}
					onClick={() => hdlKlikGigi(number,'VESTIBULAR')} />

				<polygon points="0 15, 14 29, 14 49, 0 63"
					className={"classsurface"+(sisi==="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}
					onClick={() => hdlKlikGigi(number,(sisi==="KANAN" ? "MESIAL" : "DISTAL"))} />

				<polygon points="14 29, 34 29, 34 49, 14 49"
					className={"classsurface"+vSimbolcoloroccusal}
					onClick={() => hdlKlikGigi(number,`OCCUSAL`)}/>
			</svg>
			)//>

			return (
			<svg width="48" height="78" viewBox="0 0 48 78" className="classtooth-svg">
				<text x="23" y="13" textAnchor="middle" fontSize="13">{number}</text>
				
				{vSimbolteks !== "" && (
				<text x="23" y="74" textAnchor="middle" fontSize="15" font-weight="bold">{vSimbolteks}</text>
				)}

				<polygon points="3 15, 45 15, 45 63, 3 63" alt="ALL" className={"classall"+vSimbolcolorall}/>

				{vSimbolimageArr.map((vItems,vKeys) => (<React.Fragment key={vKeys}>{vItems}</React.Fragment>))}

				<polygon points="0 15, 48 15, 34 29, 14 29"
					className={"classsurface"+vSimbolcolorvestibular}
					onClick={() => hdlKlikGigi(number,'VESTIBULAR')} />

				<polygon points="48 15, 48 63, 34 49, 34 29"
					className={"classsurface"+(sisi==="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}
					onClick={() => hdlKlikGigi(number,(sisi==="KANAN" ? "MESIAL" : "DISTAL"))} />

				<polygon points="14 49, 34 49, 48 63, 0 63"
					className={"classsurface"+vSimbolcolorlingual}
					onClick={() => hdlKlikGigi(number,'LINGUAL')} />

				<polygon points="0 15, 14 29, 14 49, 0 63"
					className={"classsurface"+(sisi!=="KANAN" ? vSimbolcolormesial : vSimbolcolordistal)}
					onClick={() => hdlKlikGigi(number,(sisi!=="KANAN" ? "MESIAL" : "DISTAL"))} />

				<polygon points="14 29, 34 29, 34 49, 14 49"
					className={"classsurface"+vSimbolcoloroccusal}
					onClick={() => hdlKlikGigi(number,'OCCUSAL')} />
			</svg>
			)//->
		});
	},[uDatashowArr.length,
	uDataprocessingArr.length,
	uInpsemuagigi,
	]);

	const contentOdontogram = () => {
		if(uHtml500msg) return "";

		if(uISCellphoneview) return (
		<div className={(uDataprocessingArr.length > 0 ? "" : "d-flex h-100")+" d-md-none align-items-center"}>
			<div className="text-center w-100">
			<div className="my-1">
				<input type="checkbox" 
					value="ALL"
					onChange={(e)=>hdlChangesemua(e)}
					id="chbswitchAll"/>
				<label htmlFor="chbswitchAll" className="ms-1 fw-bold">SEMUA GIGI</label>
			</div>

			<div className="classborderbottom my-3"/>

			<div className="my-1">
			<CInputGroup size="sm">
			<CFormSelect size="sm"
				disabled={uInpsemuagigi==="ALL"}
				value={uInpgigivalue||0}
				options={[
				"--Pilih Nomor Gigi..",
				...(uDatashowArr.map((vItems,vKeys)=>{
					return {
						label: "Gigi Nomor "+vItems.nomor_gigi,
						value: vItems.nomor_gigi,
					}
				}))]}
				onChange={(e)=>setInpgigivalue(e.target.value)}
				id="inpnomorgigi"/>
			<span className="ms-1"/>
			<CButton size="sm" color="dark" onClick={()=>hdlKlikGigi(uInpgigivalue)} id="btnTambahgigi">
				<CIcon icon="cibAddthis"/>
			</CButton>
			</CInputGroup>
			</div>
			</div>
		</div>
		)//>

		const vGigiataspermanenk1Arr = uDatashowArr.
			filter(vItems=>vItems.posisi==="ATAS" && vItems.tipe==="PERMANEN" && parseInt(vItems.kuadran) === 1).
			sort((a, b) => {
				if ( a.jenis.toUpperCase() < b.jenis.toUpperCase() ) return -1;
				if ( a.jenis.toUpperCase() > b.jenis.toUpperCase() ) return 1;
				return 0;
			});
		const vGigiataspermanenk2Arr = uDatashowArr.
			filter(vItems=>vItems.posisi==="ATAS" && vItems.tipe==="PERMANEN" && parseInt(vItems.kuadran) === 2).
			sort((a, b) => {
				if ( a.jenis.toUpperCase() < b.jenis.toUpperCase() ) return 1;
				if ( a.jenis.toUpperCase() > b.jenis.toUpperCase() ) return -1;
				return 0;
			});
		const vGigiatassusuk5Arr = uDatashowArr.
			filter(vItems=>vItems.posisi==="ATAS" && vItems.tipe!=="PERMANEN" && parseInt(vItems.kuadran) === 5).
			sort((a, b) => {
				if ( a.jenis.toUpperCase() < b.jenis.toUpperCase() ) return -1;
				if ( a.jenis.toUpperCase() > b.jenis.toUpperCase() ) return 1;
				return 0;
			});
		const vGigiatassusuk6Arr = uDatashowArr.
			filter(vItems=>vItems.posisi==="ATAS" && vItems.tipe!=="PERMANEN" && parseInt(vItems.kuadran) === 6).
			sort((a, b) => {
				if ( a.jenis.toUpperCase() < b.jenis.toUpperCase() ) return 1;
				if ( a.jenis.toUpperCase() > b.jenis.toUpperCase() ) return -1;
				return 0;
			});

		const vGigibawahpermanenk3Arr = uDatashowArr.
			filter(vItems=>vItems.posisi==="BAWAH" && vItems.tipe==="PERMANEN" && parseInt(vItems.kuadran) === 3).
			sort((a, b) => {
				if ( a.jenis.toUpperCase() < b.jenis.toUpperCase() ) return -1;
				if ( a.jenis.toUpperCase() > b.jenis.toUpperCase() ) return 1;
				return 0;
			}).sort((a,b)=>b.nomor_gigi - a.nomor_gigi)

		const vGigibawahpermanenk4Arr = uDatashowArr.
			filter(vItems=>vItems.posisi==="BAWAH" && vItems.tipe==="PERMANEN" && parseInt(vItems.kuadran) === 4).
			sort((a, b) => {
				if ( a.jenis.toUpperCase() < b.jenis.toUpperCase() ) return 1;
				if ( a.jenis.toUpperCase() > b.jenis.toUpperCase() ) return -1;
				return 0;
			}).sort((a,b)=>a.nomor_gigi - b.nomor_gigi)

		const vGigibawahsusuk7Arr = uDatashowArr.
			filter(vItems=>vItems.posisi==="BAWAH" && vItems.tipe!=="PERMANEN" && parseInt(vItems.kuadran) === 7).
			sort((a, b) => {
				if ( a.jenis.toUpperCase() < b.jenis.toUpperCase() ) return -1;
				if ( a.jenis.toUpperCase() > b.jenis.toUpperCase() ) return 1;
				return 0;
			}).sort((a,b)=>b.nomor_gigi - a.nomor_gigi)

		const vGigibawahsusuk8Arr = uDatashowArr.
			filter(vItems=>vItems.posisi==="BAWAH" && vItems.tipe!=="PERMANEN" && parseInt(vItems.kuadran) === 8).
			sort((a, b) => {
				if ( a.jenis.toUpperCase() < b.jenis.toUpperCase() ) return 1;
				if ( a.jenis.toUpperCase() > b.jenis.toUpperCase() ) return -1;
				return 0;
			}).sort((a,b)=>a.nomor_gigi - b.nomor_gigi)

		return (
		<>
		<div className="d-none d-md-block d-lg-none">
			<div className="classmodontogram">
			{vGigiataspermanenk1Arr.map((vItems,vKeys)=>{
				return (
					<ContentToothM key={vKeys} 
						number={vItems.nomor_gigi}
						posisi={vItems.posisi}
						sisi={vItems.sisi}
						jenis={vItems.jenis}/>
				)//>
			})}
			{vGigiataspermanenk2Arr.map((vItems,vKeys)=>{
				return (
					<ContentToothM key={vKeys} 
						number={vItems.nomor_gigi}
						posisi={vItems.posisi}
						sisi={vItems.sisi}
						jenis={vItems.jenis}/>
				)//>
			})}
			</div>

			<div className="classmodontogram">
			{vGigiatassusuk5Arr.map((vItems,vKeys)=>{
				return (
					<ContentToothM key={vKeys} 
						number={vItems.nomor_gigi}
						posisi={vItems.posisi}
						sisi={vItems.sisi}
						jenis={vItems.jenis}/>
				)
			})}
			{vGigiatassusuk6Arr.map((vItems,vKeys)=>{
				return (
					<ContentToothM key={vKeys} 
						number={vItems.nomor_gigi}
						posisi={vItems.posisi}
						sisi={vItems.sisi}
						jenis={vItems.jenis}/>
				)
			})}
			</div>

			<div className="classmodontogram">
			{vGigibawahsusuk7Arr.map((vItems,vKeys)=>{
				return (
					<ContentToothM key={vKeys} 
						number={vItems.nomor_gigi}
						posisi={vItems.posisi}
						sisi={vItems.sisi}
						jenis={vItems.jenis}/>
				)
			})}
			{vGigibawahsusuk8Arr.map((vItems,vKeys)=>{
				return (
					<ContentToothM key={vKeys} 
						number={vItems.nomor_gigi}
						posisi={vItems.posisi}
						sisi={vItems.sisi}
						jenis={vItems.jenis}/>
				)
			})}
			</div>

			<div className="classmodontogram">
			{vGigibawahpermanenk3Arr.map((vItems,vKeys)=>{
				return (
					<ContentToothM key={vKeys} 
						number={vItems.nomor_gigi}
						posisi={vItems.posisi}
						sisi={vItems.sisi}
						jenis={vItems.jenis}/>
				)
			})}

			{vGigibawahpermanenk4Arr.map((vItems,vKeys)=>{
				return (
					<ContentToothM key={vKeys} 
						number={vItems.nomor_gigi}
						posisi={vItems.posisi}
						sisi={vItems.sisi}
						jenis={vItems.jenis}/>
				)
			})}
			</div>
		</div>

		<div className="d-none d-lg-block">
			<div className="classodontogram">
			{vGigiataspermanenk1Arr.map((vItems,vKeys)=>{
				return (
				<ContentTooth key={vKeys} 
					number={vItems.nomor_gigi}
					posisi={vItems.posisi}
					sisi={vItems.sisi}
					jenis={vItems.jenis}/>
				)//>
			})}
			<span className="mx-1"/>
			{vGigiataspermanenk2Arr.map((vItems,vKeys)=>{
				return (
				<ContentTooth key={vKeys} 
					number={vItems.nomor_gigi}
					posisi={vItems.posisi}
					sisi={vItems.sisi}
					jenis={vItems.jenis}/>
				)//>
			})}
			</div>

			<div className="classodontogram">
			{vGigiatassusuk5Arr.map((vItems,vKeys)=>{
				return (
				<ContentTooth key={vKeys} 
					number={vItems.nomor_gigi}
					posisi={vItems.posisi}
					sisi={vItems.sisi}
					jenis={vItems.jenis}/>
				)//>
			})}
			<span className="mx-1"/>
			{vGigiatassusuk6Arr.map((vItems,vKeys)=>{
				return (
				<ContentTooth key={vKeys} 
					number={vItems.nomor_gigi}
					posisi={vItems.posisi}
					sisi={vItems.sisi}
					jenis={vItems.jenis}/>
				)//>
			})}
			</div>

			<div className="d-none">{JSON.stringify(vGigibawahsusuk7Arr)}</div>
			<div className="classodontogram">
			{vGigibawahsusuk7Arr.map((vItems,vKeys)=>{
				return (
				<>
					<ContentTooth key={vKeys} 
						number={vItems.nomor_gigi}
						posisi={vItems.posisi}
						sisi={vItems.sisi}
						jenis={vItems.jenis}/>
				</>
				)//>
			})}
			<span className="mx-1"/>
			{vGigibawahsusuk8Arr.map((vItems,vKeys)=>{
				return (
				<>
					<ContentTooth key={vKeys} 
						number={vItems.nomor_gigi}
						posisi={vItems.posisi}
						sisi={vItems.sisi}
						jenis={vItems.jenis}/>
					{vKeys===4 && (<span className="mx-1"/>)}
				</>
				)//>
			})}
			</div>

			<div className="classodontogram">
			{vGigibawahpermanenk3Arr.map((vItems,vKeys)=>{
				return (
				<ContentTooth key={vKeys} 
					number={vItems.nomor_gigi}
					posisi={vItems.posisi}
					sisi={vItems.sisi}
					jenis={vItems.jenis}/>
				)//>
			})}
			<span className="mx-1"/>
			{vGigibawahpermanenk4Arr.map((vItems,vKeys)=>{
				return (
				<ContentTooth key={vKeys} 
					number={vItems.nomor_gigi}
					posisi={vItems.posisi}
					sisi={vItems.sisi}
					jenis={vItems.jenis}/>
				)//>
			})}
			</div>
		</div>
		</>
		)//->
	}
	const contentItem = () => {
		if(uHtml500msg) return "";

		return (
		<>
		{uDataprocessingArr.length > 0 && (
		<>
		<div className="my-3"/>
		
		<div className="d-none my-2">{JSON.stringify(uDataprocessingArr)}</div>

		<table className="table table-borderless mx-auto" style={{minWidth:300,width:"50%"}}>
			<thead>
			<tr className="p-0">
				<th width={25} className="p-0"/>
				<th width="20%" className="p-0"/>
				<th className="p-0"/>
				<th width={50} className="p-0"/>
			</tr>
			</thead>
			
			<tbody className="border-top">
			{uDataprocessingArr.filter(vItems=>(vItems.status_hapus||"TIDAK")!=="YA").
				map((vItems,vKeys)=>{
				const {
					id_item,id_gigi,nomor_gigi,nama_gigi,
				} = vItems;

				return (
				<tr className="align-top border-bottom" key={vKeys}>
					<td className="px-1 text-end">{vKeys+1}.</td>
					
					<td className="px-1 text-start">No-<b>{nomor_gigi}</b></td>
					<td className="px-1 text-start">{nama_gigi}</td>
					
					<td className="px-1 text-center">
					<CLink onClick={()=>hdlKlikHapusgigi(vKeys)} className="classcursorpointer classikontabel classikonhapus"/>
					</td>
				</tr>
				)//>
			})}
			</tbody>
		</table>
		</>
		)}
		</>
		)//>
	}
	//--END CONTENT--/

	//--API--/
	const apiLoadawal = () => {
		setHtml500msg();

		setDatagigiArr([])
		setLoadingkomponen(true);

		/*//--TESTING_FRONTEND--/
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_init/ld_gigi";

		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoadingkomponen(false);
			if(output_string.tampil) {
				setDatagigiArr(JSON.parse(output_string.datagigi||"[]"));
			} else if(output_string.info) {
				setHtml500msg(output_string.info);
			} else if(output_string.errors) {
				console.log("(MyDialogodontogram - apiLoadawal) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div class='text-danger'>"+vMsg+"</div>");
			} else if(output_string.expired) {
				setLoadingkomponen(true); prosesExpired(); return;
			}
		})
		.catch((error) =>{
			setLoadingkomponen(false);
			console.log("(MyDialogodontogram - apiLoadawal) catch-error : "+error);
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		});
	}
	//--END API--/

	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});

		apiLoadawal();

		return () => {
			setDatagigiArr([]);
			uDispatch({type: "set", gigi_processing_str: undefined});
		}
	},[]);
	React.useEffect(()=>{
		//console.log("(MyDialogodontogram - [show]) uDataselectedArr",uDataselectedArr);
		if(show) {
			setDatashowArr(uDatagigiArr);
			const vDataselectedArr = [...uDataselectedArr]
			setDataprocessingArr(vDataselectedArr);
		} else 
			uDispatch({type: "set", gigi_processing_str: undefined});

		return () => {
			setLoadingkomponen(false);
			setDatashowArr([]);setDataprocessingArr([]);
			setExecutesimpan(false);
			setInpsemuagigi("");
		}
	},[show]);
	React.useEffect(()=>{
		setInpsemuagigi((uDataselectedArr[0]||{}).nomor_gigi === "ALL" ? "ALL" : "");
	},[uDataselectedArr]);
	React.useEffect(()=>{
		if(!uISExecutesimpan) return;
		setExecutesimpan(false);

		onKlikSimpan();
	},[uISExecutesimpan]);
	React.useEffect(()=>{
		if(uInpsemuagigi==="ALL") {
			setDataprocessingArr([]);
			return;
		}
	},[uInpsemuagigi]);

	return (
		<CModal alignment="center"
			size="xl"
			fullscreen={uISTabletview || uISCellphoneview}
			className="z-2099"
			visible={show} 
			scrollable
			{...rest}>
		<CModalHeader className="bg-dark text-light" closeButton={false}>
			<CModalTitle>Pilih Gigi (Odontogram)</CModalTitle>
			<CCloseButton onClick={toggle}/>
		</CModalHeader>

		<CModalBody id="idmodalbody">
		{uISLoadingkomponen ? (
			<div className="p-3 p-lg-5 text-center">
				<CSpinner color="warning"/>
			</div>
		) : (
		<>
			{uHtml500msg ? (
				<div className="p-3">
				<CCard>
				<CCardBody className="p-lg-5">
				{UFunc.renderHTML(uHtml500msg)}

				<div className="classborderbottom my-3"/>
				<CButton size="sm" color="light"
					className="text-success fw-bold border-success"
					onClick={()=>apiLoadawal()}
					id="btnRefresh">
					<CIcon icon="cilReload" className="me-1"/>
					Refresh
				</CButton>
				</CCardBody>
				</CCard>
				</div>
			) : (
			<>
				{contentOdontogram()}
				{contentItem()}
			</>
			)}
		</>
		)}
		</CModalBody>

		<CModalFooter className="justify-content-md-between">
			<div className="px-1 px-lg-3 d-none d-md-block">
			<CInputGroup>
			<CFormSwitch
				value="ALL"
				checked={uInpsemuagigi === "ALL"}
				onChange={(e)=>hdlChangesemua(e)} 
				id="inpswitchAll"/>
			<label htmlFor="inpswitchAll" className="classcursorpointer">Semua Gigi</label>
			</CInputGroup>
			</div>

			<div>
			<CButton className="px-3" color="dark"
				onClick={()=>hdlKliksimpan()}
				disabled={uHtml500msg || uISLoadingkomponen}
				id="btnPerawatsimpan">
				Simpan
			</CButton>

			<CButton className="px-3 ms-1" color="light" 
				onClick={toggle}
				id="btnPerawatbatal"> 
			{uBahasaObj.word_batal||"Batal"}
			</CButton>
			</div>
		</CModalFooter>
		</CModal>
	)//>
}

export default MyDialogodontogram;